import { TOPIKLevel } from './types';

/**
 * TOPIK 等级详细描述
 * TOPIK I: 1-2级 | TOPIK II: 3-6级
 */
export const TOPIK_LEVEL_DESCRIPTIONS: Record<
  TOPIKLevel,
  {
    name: string;
    nameKo: string;
    tier: 'TOPIK I' | 'TOPIK II';
    description: string;
    canDo: string[];
    studyHours: string;
  }
> = {
  [TOPIKLevel.Level1]: {
    name: '初级1级',
    nameKo: '1급',
    tier: 'TOPIK I',
    description: '能够完成基本的日常交流，理解和使用与个人密切相关的表达。',
    canDo: [
      '进行自我介绍和简单的日常问候',
      '理解和使用基本的生活用语',
      '进行简单的购物、点餐等日常活动',
    ],
    studyHours: '约 200-250 小时',
  },
  [TOPIKLevel.Level2]: {
    name: '初级2级',
    nameKo: '2급',
    tier: 'TOPIK I',
    description: '能够完成日常生活中的基本交流，理解和使用公共设施相关的表达。',
    canDo: [
      '处理日常生活中的基本交流',
      '使用公共设施和进行简单的电话交流',
      '理解简单的广告和公告',
    ],
    studyHours: '约 400-500 小时',
  },
  [TOPIKLevel.Level3]: {
    name: '中级3级',
    nameKo: '3급',
    tier: 'TOPIK II',
    description: '能够处理日常生活中的交流，理解和使用日常社会话题的基本表达。',
    canDo: [
      '进行日常生活中的基本交流',
      '理解和使用日常社会话题',
      '区分口语和书面语的基本特征',
    ],
    studyHours: '约 600-750 小时',
  },
  [TOPIKLevel.Level4]: {
    name: '中级4级',
    nameKo: '4급',
    tier: 'TOPIK II',
    description: '能够处理公共设施中的交流，理解新闻和一般社会话题。',
    canDo: [
      '在公共设施中进行交流',
      '理解新闻、广播等一般社会话题',
      '理解和使用较抽象的日常话题',
    ],
    studyHours: '约 800-1000 小时',
  },
  [TOPIKLevel.Level5]: {
    name: '高级5级',
    nameKo: '5급',
    tier: 'TOPIK II',
    description: '能够处理专业领域的研究或业务所需的一定程度的韩语。',
    canDo: [
      '理解政治、经济、社会、文化等专业领域的话题',
      '在专业领域进行研究或业务',
      '理解和使用不熟悉的话题',
    ],
    studyHours: '约 1000-1200 小时',
  },
  [TOPIKLevel.Level6]: {
    name: '高级6级',
    nameKo: '6급',
    tier: 'TOPIK II',
    description: '能够熟练地处理专业领域的研究或业务所需的韩语。',
    canDo: [
      '在专业领域进行研究和业务',
      '理解和使用政治、经济、社会、文化等各类话题',
      '虽未达到母语者水平，但能准确流畅地表达和使用',
    ],
    studyHours: '约 1200+ 小时',
  },
};

/**
 * 获取等级描述
 */
export function getLevelDescription(level: TOPIKLevel) {
  return TOPIK_LEVEL_DESCRIPTIONS[level];
}

/**
 * 获取下一个等级
 */
export function getNextLevel(currentLevel: TOPIKLevel): TOPIKLevel | null {
  const levels = Object.values(TOPIKLevel);
  const currentIndex = levels.indexOf(currentLevel);
  if (currentIndex < levels.length - 1) {
    return levels[currentIndex + 1];
  }
  return null;
}

/**
 * 比较两个等级
 * 返回 -1 如果 a < b，0 如果 a = b，1 如果 a > b
 */
export function compareLevels(a: TOPIKLevel, b: TOPIKLevel): number {
  const levels = Object.values(TOPIKLevel);
  const indexA = levels.indexOf(a);
  const indexB = levels.indexOf(b);
  return Math.sign(indexA - indexB);
}
